module.exports = __webpack_public_path__ + "static/img/logo_horizontal.ee4982c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_horizontal.jpg
// module id = vSwF
// module chunks = 1